/* Model */
class TaskTypeModel extends App.Models.BaseModel {
    modelUrl = 'TaskType';
}

App.Models.TaskType = TaskTypeModel;

/* Collection */
class TaskTypeCollection extends App.Collections.BaseCollection {
    url = 'TaskType';
    model = App.Models.TaskType;
}

App.Collections.TaskTypes = TaskTypeCollection;

/* Router */
export class TaskTypeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'TaskType';
        const model = App.Models.TaskType;
        const collectionClass = App.Collections.TaskTypes;

        super(entityName, model, collectionClass);
    }

    iconOptions = [ //need to be here to work in "index", "new" and "edit" stageCrud
        'gmfont-task-type-icon-default',
        'gmfont-task-type-icon-bottle-selection',
        'gmfont-task-type-icon-climb-stairs',
        'gmfont-task-type-icon-incorrect-geocode',
        'gmfont-task-type-icon-incorrect-time-window',
        'gmfont-task-type-icon-insecurity',
        'gmfont-task-type-icon-location-not-found',
        'gmfont-task-type-icon-parking-dificulties path1 path2',
        'gmfont-task-type-icon-prohibited-access',

    ]

    setupIconField = () => {
        const form = App.Forms.TaskType.form;
        const setValueTo = (iconField) => {
            let icon = 'gmfont-task-type-icon-default';
            if(form.model && form.model.attributes && form.model.attributes.icon) {
                icon = form.model.attributes.icon ;
            }
            iconField.setValue(icon);
        };

        if(form && form.fields && form.fields.icon) {
            
                const iconField = form.fields.icon;

                iconField.setTextLabel(Monet.I18n.getResourcesByKey('TaskType.generalInfo.icon'));
                iconField.setId(`${this.entityName}_${iconField.field.name}`);
                setValueTo(iconField);
        }
    };

    afterPopulateGrid = () => {
        this.setupIconField();
        this.checkAssignmentsRules();
        this.preparePredeterminedMessageSection();
    };

    afterPopulateForm = () => {
        this.setupIconField();
        this.checkAssignmentsRules();
        this.preparePredeterminedMessageSection();
    };

    checkAssignmentsRules = () => {
        const isEmpty = (obj) => {
            for(var key in obj) {
                if(obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        };
        
        const assignmentsSectionFields = ['standardAssignedUserId', 'standardAssignedGroupId'];
        
        const enableDisableLookupFields = (field) => {
            const value = fields[field].getValue();
                
            if(value !== '') {
                if(field === assignmentsSectionFields[0]) {
                    fields[assignmentsSectionFields[1]].disable();
                } else {
                    fields[assignmentsSectionFields[0]].disable();
                }
            } else {
                if(field === assignmentsSectionFields[0]) {
                    fields[assignmentsSectionFields[1]].enable();
                } else {
                    fields[assignmentsSectionFields[0]].enable();
                }
            }
        };

        const disableFields = (fields, fieldsName) => {
            fieldsName.forEach( name => {
                fields[name].clear({ doNotTriggerChange : true });
                fields[name].disable();
            });
        };

        const form = App.Forms[this.entityName].form;
        const fields = form && form.fields;
        
        if(form && !isEmpty(fields)) {
            assignmentsSectionFields.forEach( field => {
                enableDisableLookupFields(field);

                fields[field].setOnBlur(() => {
                    enableDisableLookupFields(field);
                });
            });

            //CheckBox rules
            const assignToMySelfCheckBox = fields['assignToMySelf'];
            const checked = assignToMySelfCheckBox.getValue();
            if(checked) {
                disableFields(fields, assignmentsSectionFields);
            }

            assignToMySelfCheckBox.addClickEventListener(() => {

                const checked = assignToMySelfCheckBox.getValue();

                if(checked) {
                    disableFields(fields, assignmentsSectionFields);
                } else {
                    assignmentsSectionFields.forEach( field => {
                        fields[field].enable();
                    });
                }
            });
        }
    };
    
    preparePredeterminedMessageSection = () => {
        const form = App.Forms.TaskType.form;
        this.renderAddAttributesFieldTo(form);
        this.renderSubtitle(form);

    };

    renderAddAttributesFieldTo = (form) => {
        const entitiesPropertiesList = [
            "Equipment.key",
            "Equipment.description",
            "Equipment.equipmentType.key",
            "Equipment.equipmentType.description",
            "Equipment.equipmentType.weight",
            "Equipment.equipmentType.height",
            "Equipment.equipmentType.size1",
            "Equipment.equipmentType.size2",
            "Equipment.equipmentType.size3",
            "Stop.location.key",
            "Stop.location.accountType.key",
            "Stop.location.accountType.description",
            "Stop.location.locationType.key",
            "Stop.location.locationType.description",
            "Stop.location.timeWindowType.key",
            "Stop.location.timeWindowType.description",
            "Stop.location.serviceTimeType.key",
            "Stop.location.serviceTimeType.description",
            "Stop.location.description",
            "Stop.location.addressLine1",
            "Stop.location.addressLine2",
            "Stop.location.city",
            "Stop.location.state",
            "Stop.location.zipCode",
            "Stop.location.district",
            "Stop.location.longitude",
            "Stop.location.latitude",
            "Stop.location.phone1",
            "Stop.location.phone1Type",
            "Stop.location.phone2",
            "Stop.location.phone2Type",
            "Stop.location.email",
            "Stop.location.deliveryInstructions",
            "Stop.key",
            "Stop.baseLineSequenceNum",
            "Stop.plannedSequenceNum",
            "Stop.actualSequenceNum",
            "Stop.stopType.description",
            "Stop.baseLineArrival",
            "Stop.plannedArrival",
            "Stop.projectedArrival",
            "Stop.actualArrival",
            "Stop.baseLineService",
            "Stop.plannedService",
            "Stop.projectedService",
            "Stop.actualService",
            "Stop.baseLineDeparture",
            "Stop.plannedDeparture",
            "Stop.projectedDeparture",
            "Stop.actualDeparture",
            "Stop.baseLineDistance",
            "Stop.plannedDistance",
            "Stop.projectedDistance",
            "Stop.actualDistance",
            "Stop.baseLineSize1",
            "Stop.baseLineSize2",
            "Stop.baseLineSize3",
            "Stop.plannedSize1",
            "Stop.plannedSize2",
            "Stop.plannedSize3",
            "Stop.actualSize1",
            "Stop.actualSize2",
            "Stop.actualSize3",
            "Stop.plannedPickupSize1",
            "Stop.plannedPickupSize2",
            "Stop.plannedPickupSize3",
            "Stop.baseLinePickupSize1",
            "Stop.baseLinePickupSize2",
            "Stop.baseLinePickupSize3",
            "Stop.actualPickupSize1",
            "Stop.actualPickupSize2",
            "Stop.actualPickupSize3",
            "Stop.damagedSize1",
            "Stop.damagedSize2",
            "Stop.damagedSize3",
            "Stop.instructions",
            "Stop.deliveryReasonCode.description",
            "Stop.overReasonCode.description",
            "Stop.shortReasonCode.description",
            "Stop.damagedReasonCode.description",
            "Stop.pickupReasonCode.description",
            "Stop.cancelCode.description",
            "Stop.undeliverableCode.description",
            "Stop.arrivalLatitude",
            "Stop.arrivalLongitude",
            "Stop.arrivalAccuracyMeters",
            "Stop.arrivedInTimeWindow",
            "Stop.serviceLatitude",
            "Stop.serviceAccuracyMeters",
            "Stop.serviceLongitude",
            "Stop.longitude",
            "Stop.latitude",
            "Stop.ordersInfo",
            "Route.date",
            "Route.key",
            "Route.description",
            "Route.origin.key",
            "Route.origin.description",
            "Route.origLatitude",
            "Route.origLongitude",
            "Route.destination.key",
            "Route.destination.description",
            "Route.destLatitude",
            "Route.destLongitude",
            "Route.baseLineArrival",
            "Route.baseLineDeparture",
            "Route.plannedArrival",
            "Route.plannedDeparture",
            "Route.actualArrival",
            "Route.actualDeparture",
            "Route.baseLineDistance",
            "Route.plannedDistance",
            "Route.actualDistance",
            "Route.baseLineComplete",
            "Route.plannedComplete",
            "Route.actualComplete",
            "Route.baseLineCost",
            "Route.plannedCost",
            "Route.actualCost",
            "Route.baseLineStart",
            "Route.plannedStart",
            "Route.actualStart",
            "Route.hasHelper",
            "Route.driversName",
            "Route.totalStops",
            "Route.canceledStops",
            "Route.undeliveredStops",
            "Route.redeliveredStops",
            "Route.actualTravelTimeMinutes",
            "Route.plannedTravelTimeMinutes",
            "Route.baselineTravelTimeMinutes",
            "Route.hasPicture",
            "Driver.key",
            "Driver.name",
            "Driver.login",
            "HoursOfService.onDuty"
        ];

        if(form && form.fields) {
            ["standardTaskTitle", "standardTaskDescription"].forEach( field => {
                const fields = form.fields;

                fields[field] 
                    && new Greenmile.Components.AddAttribute(fields[field], entitiesPropertiesList)
                        .render();
            });
        }
    };

    renderSubtitle = (form) => {
        const section =  form && form.rootEl.querySelector('[key*="predeterminedMessage_taskType"]');
        const content = section && section.querySelector('.MonetUIFormSectionFields');
        if(content) {
            const divSubTitle = document.createElement('div');
            divSubTitle.setAttribute('class', `predeterminedMessage__subtitle`);

            divSubTitle.innerHTML = Monet.I18n.getResourcesByKey('taskType.predeterminedMessage.subtitle');
            content.insertBefore(divSubTitle, content.firstChild);
        } 
    };

    beforeValidate(form) {
        const fields = form?.fields;
        const { standardTaskTitle, enabledToDrivers } = fields ?? {};

        this.handleBlankSpaceIn(standardTaskTitle);
        this.handleWhenEnableToDriverAppIsChecked(standardTaskTitle, enabledToDrivers);
    };

    handleWhenEnableToDriverAppIsChecked(standardTaskTitle, enabledToDrivers) {
        if (standardTaskTitle && enabledToDrivers) {
            const isChecked = enabledToDrivers.getValue();
            const isMandatory = isChecked;
            standardTaskTitle.setMandatory(isMandatory);
        } else {
            new Monet.Exception.ReturnError(
                this,
                "Task Title and/or Enable to Driver fields are not present."
            ).console();
        }
    };

    handleBlankSpaceIn(field) {
        const value = field.getValue();
        const valueTrimed = value.trim();
        field.setValue(valueTrimed);
    };
}

App.Routers.TaskType = TaskTypeRouter;
